import {ActionType} from 'redux-promise-middleware';
import {ROUTER_DATA_LOAD_FULFILLED} from '../router/router-actions';
import {
    FETCH_RESERVATION,
    REFUND_RESERVATION,
    PARKING_PASS_SET_ERROR,
    TOGGLE_MODAL,
    UPDATE_PHONE,
    UPDATE_VEHICLE,
    REFETCH_RESERVATION,
} from './parking-pass-actions';
import ReservationUtils from 'utils/reservation-utils';

export const REFUND = 'refund';
export const CHANGE_VEHICLE = 'vehicle';
export const CHANGE_PHONE = 'phone';
export const CHANGE_TIMES = 'times';

export const initialState = () => ({
    isPending: false,
    accessKey: null,
    data: {},
    error: null,
    modals: {
        [CHANGE_VEHICLE]: false,
        [REFUND]: false,
        [CHANGE_PHONE]: false,
        [CHANGE_TIMES]: false,
    },
});

export default function parkingPass(state = initialState(), {type, payload}) {
    switch (type) {
        case ROUTER_DATA_LOAD_FULFILLED: {
            return {
                ...state,
                ...payload.parkingPass,
            };
        }

        case `${FETCH_RESERVATION}_${ActionType.Pending}`: {
            return {
                ...state,
                isPending: true,
                error: null,
            };
        }

        case `${FETCH_RESERVATION}_${ActionType.Fulfilled}`:
        case `${REFETCH_RESERVATION}_${ActionType.Fulfilled}`:
        case `${UPDATE_VEHICLE}_${ActionType.Fulfilled}`:
        case `${UPDATE_PHONE}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                isPending: false,
                data: payload,
            };
        }

        case `${REFUND_RESERVATION}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                isPending: false,
                data: {
                    ...state.data,
                    paymentStatus: payload.paymentStatus,
                    canUpdateStartsAndEnds: payload.canUpdateStartsAndEnds,
                },
            };
        }

        case `${FETCH_RESERVATION}_${ActionType.Rejected}`: {
            return {
                ...state,
                isPending: false,
                error: ReservationUtils.getErrorTypeFromServerError(payload),
            };
        }
        case PARKING_PASS_SET_ERROR: {
            return {
                ...state,
                error: payload,
            };
        }
        case TOGGLE_MODAL: {
            return {
                ...state,
                modals: {
                    ...state.modals,
                    [payload]: !state.modals[payload],
                },
            };
        }
        default: {
            return state;
        }
    }
}
